import { useState } from "react";
import axios from "axios";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { FileOpener } from "@capacitor-community/file-opener";
import { blobToBase64 } from "@/utils/blobToBase64";
import { LoaderSpinner } from "@/components/ui/LoaderSpinner";
import { Button } from "@/components/ui/button";
import certificateIcon from "../../assets/userProfil/certificatMock.png";
import { useAuth } from "@/context/AuthContext";

export const CoursesCertificats = (props: {
	courseName: string;
	courseId: number;
}): JSX.Element => {
	const { courseName, courseId } = props;
	const [certificateLoader, setCertificateLoader] = useState<string | null>(
		null
	);
	const { token } = useAuth();

	const downloadCertificate = async (file: {
		name: string;
		courseId: number;
	}): Promise<void> => {
		setCertificateLoader(file.name);
		try {
			const response = await axios.get<Blob>(
				`https://akademialtca.pl/api/certificate/${courseId}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/pdf",
						Accept: "application/pdf",
					},
					responseType: "blob",
				}
			);

			if (Capacitor.isNativePlatform()) {
				// Handle mobile download
				const base64Data = await blobToBase64(response.data);
				const fileName = file.name;

				await Filesystem.writeFile({
					path: `${fileName}.pdf`,
					data: base64Data,
					directory: Directory.Documents,
					recursive: true,
				});

				// Get the file URI
				const fileUri = await Filesystem.getUri({
					directory: Directory.Documents,
					path: `${fileName}.pdf`,
				});

				// Open the file
				await FileOpener.open({
					filePath: fileUri.uri,
					contentType: "application/pdf",
				});
			} else {
				// Handle web download
				const url = window.URL.createObjectURL(
					new Blob([response.data], { type: "application/pdf" })
				);
				const link = document.createElement("a");
				link.href = url;
				link.download = file.name;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			}
			setCertificateLoader(null);
		} catch (error) {
			setCertificateLoader(null);
			console.error("Error downloading file:", error);
		}
	};

	return (
		<div className="mb-[15px] bg-white rounded-[8px] p-4">
			<div>
				<div className="flex mb-[13px]">
					<img alt="resource image" className="w-[93px] h-[68px]" src={certificateIcon} />
					<p className="font-medium ml-[10px]">{courseName}</p>
				</div>
				<div className="flex justify-end items-center">
					{/* <p className="text-[#637381] text-sm mr-[15px]">
						{el.endDate && `Data ukończenia ${el.endDate}`}
						{el.publicationDate && `Data publikacji ${el.publicationDate}`}
					</p> */}
					{certificateLoader === courseName && (
						<LoaderSpinner className="mr-3" size={6} />
					)}
					<Button
						className=" border-[1px] border-[#919EAB3D]  h-[30px] mr-[10px] px-2 py-1"
						variant="ghost"
						onClick={async () => {
							await downloadCertificate({
								name: courseName,
								courseId,
							});
						}}
					>
						Pobierz
					</Button>
				</div>
			</div>
		</div>
	);
};